import React from 'react';
import './PrivacyPolicyModal.css';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-button" onClick={onClose}>×</button>
        <h1 className="modal-title">Privaatsuspoliitika</h1>

        <p>Käesolev küpsiste kasutamise ja privaatsuspoliitika teavitus sisaldab kasulikku infot selle kohta, kuidas ja milleks AI-TEAM OÜ AI-fotogeneraatori kasutamiseks vajalikke isikuandmeid kogub, töötleb ja jagab.</p>

        <p>Privaatsuspoliitika lähtub andmekaitse üldregulatsioonist (GDPR - General Data Protection Regulation). Privaatsuspoliitika eesmärk on kaitsta klientide privaatsust kooskõlas Eesti Vabariigi seaduste ning Euroopa Liidu õigusaktidega.</p>

        <p>Privaatsustingimused kohalduvad kõikide kogutud isikuandmetele ja privaatsustingimuste kohustustest lähtuvad kõik AI-TEAM OÜ töötajad ja koostööpartnerid, kellel on kokkupuude AI-TEAM OÜ valduses olevate isikuandmetega.</p>

        <p>Privaatsustingimused reguleerivad isikuandmete töötlemist AI-fotogeneraatoris.</p>

        <p>Isikuandmete töötlemisel ja säilitamisel rakendab AI-TEAM OÜ organisatoorseid ja tehnilisi meetmeid, mis tagavad isikuandmete kaitse juhusliku või ebaseadusliku hävitamise, muutmise, avalikustamise ja mis tahes muu ebaseadusliku töötlemise eest.</p>

        <p>Isikuandmete käsitlemisega seotud lisaküsimuste puhul võite pöörduda: <a href="mailto:info@portrai.ee" className="email-link">info@portrai.ee</a></p>

        <h2 className="modal-section-title">Töödeldavad andmed</h2>

        <table className="privacy-table">
          <thead>
            <tr>
              <th>Andmed</th>
              <th>Eesmärk</th>
              <th>Säilitustähtaeg</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Näopilt (originaal)</td>
              <td>AI-foto genereerimine</td>
              <td>Kustutatakse kohe pärast töötlust</td>
            </tr>
            <tr>
              <td>Genereeritud AI-pilt</td>
              <td>Pildi jagamisviiside funktsionaalsus</td>
              <td>Kuni 31.12.2025 23:59 EEST</td>
            </tr>
            <tr>
              <td>Tehnilised logi-andmed</td>
              <td>Turvalisus ja tõrkeanalüüs</td>
              <td>Kuni 31.12.2025 23:59 EEST</td>
            </tr>
          </tbody>
        </table>

        <div className="modal-footer-text">
          <p>Kasutades fotogeneraatorit annad õiguse andmete töötlemiseks kooskõlas käesolevate privaatsustingimustega.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
